import { checkIsUrlInvalid } from "@/services/tools/urlValidation/checkIsUrlInvalid";
import { Form, FormPageTypeEnum, FormPayload } from "@dev/ee-api/ee-api-models";

const checkFormSettingsFieldsExists = (formPayload: FormPayload, formObject: Form): boolean => {
    const activationEmailTemplate = formPayload?.ActivationTemplateName ?? formObject?.ActivationTemplateName;
    const doubleOptInPage = formPayload?.DoubleOptInPage ?? formObject?.DoubleOptInPage;
    const formAlreadySubscribedPage = formPayload?.FormAlreadySubscribedPage ?? formObject?.FormAlreadySubscribedPage;
    const formSubmitPage = formPayload?.FormSubmitPage ?? formObject?.FormSubmitPage;

    return (
        typeof activationEmailTemplate !== 'undefined' &&
        typeof doubleOptInPage !== 'undefined' &&
        typeof formAlreadySubscribedPage !== 'undefined' &&
        typeof formSubmitPage !== 'undefined' 
    )
}

export const getStep3Validity = (formPayload: FormPayload, formObject: Form): boolean => {
    if (!formPayload) return false;
    
    return (
        !checkFormSettingsFieldsExists(formPayload, formObject) ||
        formPayload?.FormPageType?.[0] === FormPageTypeEnum.LandingPageDoubleOptInPage && !formPayload?.DoubleOptInPage ||
        formPayload?.FormPageType?.[1] === FormPageTypeEnum.LandingPageFormSubmitPage && !formPayload?.FormSubmitPage ||
        formPayload?.FormPageType?.[2] === FormPageTypeEnum.LandingPageFormSubscribedPage && !formPayload?.FormAlreadySubscribedPage ||
        formPayload?.FormPageType?.[0] === FormPageTypeEnum.ExternalWebsiteDoubleOptInPage && (!formPayload?.DoubleOptInPage || checkIsUrlInvalid(formPayload?.DoubleOptInPage)) ||
        formPayload?.FormPageType?.[1] === FormPageTypeEnum.ExternalWebsiteFormSubmitPage && (!formPayload?.FormSubmitPage || checkIsUrlInvalid(formPayload?.FormSubmitPage)) ||
        formPayload?.FormPageType?.[2] === FormPageTypeEnum.ExternalWebsiteFormSubscribedPage && (!formPayload?.FormAlreadySubscribedPage || checkIsUrlInvalid(formPayload?.FormAlreadySubscribedPage))
    )
}